// Relatório de Campanhas (Relatórios → Relatório de Ofertas → Campanhas): hub com
// um card por campanha com relatório próprio (Campanha Inteligente, Recuperador de Vendas e Sugestões Inteligentes).

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, ArrowRight, Lightbulb, Sparkles, Zap } from "lucide-react";

import { ROTA_RELATORIO } from "../features/ofertas-do-dia/admin/rotas";
import { ROTA_RELATORIO_RECUPERADOR } from "../features/recuperador/rotas";
import { ROTA_RELATORIO_SUGESTOES } from "../features/sugestoes/admin/rotas";
import { Skeleton } from "../components/ui/skeleton";

const API = "/api";

export default function RelatorioCampanhas() {
  const navigate = useNavigate();
  // null = ainda carregando: o selo Ligada/Desligada pisca até chegar.
  const [campanhas, setCampanhas] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios.get(`${API}/campaigns`, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => setCampanhas(data || []))
      .catch(() => setCampanhas([]));
  }, []);
  const porTipo = (tipo) => (campanhas || []).find((c) => c.type === tipo) || null;

  const disponiveis = [
    { tipo: "daily_offers", rota: ROTA_RELATORIO, e2e: "card-relatorio-campanha-inteligente", icon: Sparkles, cor: "text-purple-500", bg: "bg-purple-500/10",
      titulo: "Campanha Inteligente", desc: "Pedidos e desconto concedido, a caça às ofertas, cadastros novos e tempo no cardápio." },
    { tipo: "sales_recovery", rota: ROTA_RELATORIO_RECUPERADOR, e2e: "card-relatorio-recuperador", icon: Zap, cor: "text-amber-500", bg: "bg-amber-500/10",
      titulo: "Recuperador de Vendas", desc: "Mensagens da CLEO, pedidos e receita recuperados, funil e comparação de períodos." },
    { tipo: "cross_sell", rota: ROTA_RELATORIO_SUGESTOES, e2e: "card-relatorio-sugestoes", icon: Lightbulb, cor: "text-sky-500", bg: "bg-sky-500/10",
      titulo: "Sugestões Inteligentes", desc: "Exibidas, adicionadas, receita extra, ticket com e sem sugestão e o que seus clientes pedem junto." },
  ];
  const emBreve = [];

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        <button type="button" onClick={() => navigate("/admin/impulsione/relatorio-ofertas")}
          className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors mb-3">
          <ArrowLeft className="w-4 h-4" /> Relatório de Ofertas
        </button>
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold tracking-tight">Relatório de Campanhas</h1>
          <p className="text-muted-foreground mt-1">Escolha uma campanha para ver o desempenho detalhado</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {disponiveis.map(({ tipo, rota, e2e, icon: Icon, cor, bg, titulo, desc }) => {
            const camp = porTipo(tipo);
            return (
              <button key={tipo} type="button" onClick={() => navigate(rota)} data-e2e={e2e}
                className="group text-left bg-card rounded-xl border-2 border-primary/30 p-6 shadow-md hover:shadow-lg hover:border-primary transition-all">
                <div className="flex items-center justify-between mb-4">
                  <div className={`w-12 h-12 ${bg} rounded-lg flex items-center justify-center`}>
                    <Icon className={`w-6 h-6 ${cor}`} strokeWidth={1.5} />
                  </div>
                  {campanhas === null && <Skeleton className="h-6 w-20 rounded-full" />}
                  {camp && (
                    <span className={`text-[11px] font-bold uppercase tracking-wide px-2.5 py-1 rounded-full ${camp.is_active ? "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400" : "bg-muted text-muted-foreground"}`}>
                      {camp.is_active ? "Ligada" : "Desligada"}
                    </span>
                  )}
                </div>
                <h3 className="font-semibold text-lg mb-1">{titulo}</h3>
                <p className="text-sm text-muted-foreground mb-4">{desc}</p>
                <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary">
                  Ver relatório <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                </span>
              </button>
            );
          })}
          {emBreve.map(({ icon: Icon, cor, bg, titulo, desc }) => (
            <div key={titulo} className="bg-card rounded-xl border p-6 opacity-70 cursor-not-allowed" title="Em breve">
              <div className="flex items-center justify-between mb-4">
                <div className={`w-12 h-12 ${bg} rounded-lg flex items-center justify-center`}><Icon className={`w-6 h-6 ${cor}`} strokeWidth={1.5} /></div>
                <span className="text-[11px] font-bold uppercase tracking-wide px-2.5 py-1 rounded-full bg-amber-500/15 text-amber-600 dark:text-amber-400">Em breve</span>
              </div>
              <h3 className="font-semibold text-lg mb-1">{titulo}</h3>
              <p className="text-sm text-muted-foreground">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
